<script lang="ts">
  export let teamName: string;
  export let imgUrl: string;
  export let whoseTurn: string;
  export let points: number;
</script>

<style>
  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 5px;
  }

  figure {
    width: 60%;
    margin: 0;
    padding: 5px;
    border: 4px solid hsla(120, 76%, 100%, 1);
    transition: border 0.5s linear 1s;
  }

  img {
    width: 100%;
  }

  figcaption {
    text-align: center;
    font-size: 1.1rem;
    text-transform: uppercase;
    font-weight: 800;
  }

  @keyframes blink {
    to {
      opacity: 0;
    }
  }

  .active {
    border: 4px solid hsla(29, 100%, 55%, 1);
    /* animation: blink 0.3s 10 ease-in-out alternate; */
  }

  .score-cont {
    text-align: center;
  }

  p {
    margin: 10px 0 0;
    font-size: 1rem;
    font-weight: 400;
  }

  h3 {
    font-size: 2.3rem;
    margin: 0;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 280px) {
    p,
    figcaption {
      font-size: 0.8rem;
    }
  }

  @media only screen and (max-width: 360px) {
  }

  @media only screen and (min-width: 768px) {
    section {
      margin: 0 6%;
    }

    p,
    figcaption {
      font-size: 1.5rem;
    }

    h3 {
      font-size: 3.5rem;
    }

    figure {
      width: 80%;
    }
  }
  @media only screen and (min-width: 992px) {
    section {
      margin: 0 11%;
    }
  }
</style>

<section>
  <figure class:active={whoseTurn === teamName}>
    <figcaption>{teamName}</figcaption>
    <img src={imgUrl} alt={teamName} />
  </figure>
  <div class="score-cont">
    <p>SCORE</p>
    <h3>{points}</h3>
  </div>
</section>
